import { render, staticRenderFns } from "./checkCard.vue?vue&type=template&id=72faa920&scoped=true&"
import script from "./checkCard.vue?vue&type=script&lang=js&"
export * from "./checkCard.vue?vue&type=script&lang=js&"
import style0 from "./checkCard.vue?vue&type=style&index=0&id=72faa920&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72faa920",
  null
  
)

export default component.exports